(function () {
  function initArrows() {
    // Adjust selector if your theme uses a different wrapper
    const media = document.querySelector(".product-media");
    if (!media) return;

    // Find existing slider buttons (many Shopify themes already have these)
    const nextBtn =
      media.querySelector('[aria-label*="Next"], .slider-button--next, button[name="next"], .swiper-button-next');
    const prevBtn =
      media.querySelector('[aria-label*="Previous"], .slider-button--prev, button[name="previous"], .swiper-button-prev');

    // If we can't find slider controls, don't add arrows
    if (!nextBtn || !prevBtn) return;

    // Avoid duplicates
    if (media.querySelector(".hoe-media-arrow")) return;

    const makeArrow = (dir) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = `hoe-media-arrow hoe-media-arrow--${dir}`;
      b.setAttribute("aria-label", dir === "prev" ? "Previous image" : "Next image");
      b.innerHTML = dir === "prev" ? "‹" : "›";
      b.addEventListener("click", () => (dir === "prev" ? prevBtn.click() : nextBtn.click()));
      return b;
    };

    media.style.position = "relative";
    media.appendChild(makeArrow("prev"));
    media.appendChild(makeArrow("next"));
  }

  document.addEventListener("DOMContentLoaded", initArrows);
  document.addEventListener("shopify:section:load", initArrows);
})();
